import { render } from "./MemberForm.vue?vue&type=template&id=6ccf36ca&scoped=true&bindings={\"selected\":\"data\",\"to\":\"data\",\"firstName\":\"data\",\"lastName\":\"data\",\"spouse\":\"data\",\"houseHold\":\"data\",\"submitForm\":\"options\"}"
import script from "./MemberForm.vue?vue&type=script&lang=js"
export * from "./MemberForm.vue?vue&type=script&lang=js"

import "./MemberForm.vue?vue&type=style&index=0&id=6ccf36ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6ccf36ca"

export default script